import React from 'react'

const CardGroup = () => {
    return (
        <div className="card-wrap">
            <h4>Department Events and Achievements</h4>
            <div className="card-flex">
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/c1.jpg" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">A 10 days Training Program on “Big Data Analytics”</h5>
                        <p className="card-text">
                            The training program on Big Data Analytics sponsored by Department of Science & Technology (Big
                            Data Initiatives Division) of Government of India, was held at National Institute of Technology
                            Srinagar from 10th March 2017 to 20th march 2017. The dates of registration were up to 8th March
                            2017 and 139 candidates registered for the program. The program schedule was followed strictly
                            as per the guidelines provided by DST (Big Data Initiatives Division).
                        </p>
                    </div>
                </div>
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/c2.jpg" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">Techvaganza, The Annual Techfest</h5>
                        <p className="card-text">
                            Techvaganza is a national level technical festival held annually at National institute of
                            technology Srinagar in Srinagar. It is the first Techno-Management festival in region. With the
                            initiation of Techvaganza in 2009, it has emerged as one of the biggest technical carnival among
                            all. The main aim is to uplift the technical level of the region and provide a platform for
                            technical tender buds to innovate, fabricate and gain experience in the field of technology and
                            management.
                        </p>
                    </div>
                </div>
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/c3.jpg" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">National Unity day Celebration</h5>
                        <p className="card-text">
                            National Institute of Technology Srinagar celebrated National Unity Day in the institute campus
                            on 31st October, 2018. On the occasion, students took a pledge to strengthen the sovereignty and
                            unity of the nation and participated in a marathon. The winner in boys category was Mukesh Kumar
                            from department of IT.The best 3 runners in either category (Boys and Girls) were awarded in
                            cash.
                        </p>
                    </div>
                </div>
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/c4.jfif" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">The Semicolon Coding Club</h5>
                        <p className="card-text">
                            The semicolon coding club established by students of NIT Srinagar organizes workshops and
                            training sessions on coding etc. for fellow students of the institute on regular basis. Like
                            many other events HACKATHON, a workshop in Ethical hacking and cyber security was held in
                            September 2018. Exordium 2017, a Code fest of NIT Srinagar was held by the club from 3rd
                            November to 7th November 2017.
                        </p>
                    </div>
                </div>
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/c5.jfif" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">Annual Farewell ceremony for outgoing students</h5>
                        <p className="card-text">
                            The department of Information Technology hosted a farewell party in the honor of the outgoing
                            students of final year at the college campus. The gathering provided both faculty and students
                            an opportunity to have interaction on a wide range of issues including their future pursuits.
                        </p>
                    </div>
                </div>
                <div className="card responsiveCard about-box-shadow"  >
                    <img src="/img/project1.jpg" className="card-img-top" alt="png" />
                    <div className="card-body">
                        <h5 className="card-title">DADS: Distributed Attestation for Device Swarms</h5>
                        <p className="card-text">
                            Swarms
                            Emerging trends in embedded systems, such as applications on Industrial control and IoTs,
                            involve heterogeneous and mobile devices to communicate, process and exchange safety, privacy
                            and mission critical information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardGroup